import { featuredCategories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="relative bg-primary-900 py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="absolute top-0 left-0 w-[600px] h-[600px] rounded-full bg-background-50 blur-[150px]"></div>
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] rounded-full bg-accent-500 blur-[150px]"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-14 gap-6">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-background-50/20 text-background-50/70 text-xs font-medium mb-4">
              <i className="ri-fire-line text-accent-400"></i>
              Trending
            </div>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
              Explore Popular
              <br />
              Categories
            </h2>
          </div>
          <p className="text-background-50/50 text-sm max-w-xs leading-relaxed">
            Jump straight into the most popular pandabuyspreadsheet categories — curated daily with
            the freshest finds.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-2xl overflow-hidden bg-background-50/5 border border-background-50/10 hover:border-background-50/20 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={cat.image}
                  alt={`Pandabuyspreadsheet ${cat.name} category`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-primary-950/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-background-50 mb-1">
                  {cat.name}
                </h3>
                <p className="text-background-50/60 text-xs">{cat.subtitle}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 text-center">
          <button
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-50/20 text-background-50/80 text-sm font-medium hover:bg-background-50/10 hover:border-background-50/30 transition-all duration-300 cursor-pointer whitespace-nowrap"
            onClick={() => {
              const el = document.getElementById("categories-section");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
          >
            View All 14 Categories
            <i className="ri-arrow-right-line text-base"></i>
          </button>
        </div>
      </div>
    </section>
  );
}